module.exports = __webpack_public_path__ + "static/media/E8.a92644a3.jpeg";